import { NamePrefixModifier, withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { PageSection } from 'Components/Layout';
import { WorksheetImagesAndRemarksSection, WorksheetRootComponent, WorksheetTestedBySection } from '../../Core';
import qestIds from '../../QestIds';
import { MeasurementsSection, PreparationSection, ResultsSection } from './Sections';

let AsDynamicConePenetrometerWorksheet: WorksheetRootComponent = ({ createWorksheetSelector }) => {
  return (
    <>
      <PageSection heading="Preparation">
        <NamePrefixModifier appendNamePrefix="Preparation">
          <PreparationSection />
        </NamePrefixModifier>
      </PageSection>
      <PageSection heading="Measurements">
        <MeasurementsSection />
      </PageSection>
      <PageSection>
        <WorksheetTestedBySection />
      </PageSection>
      <ResultsSection />
      <PageSection heading="Image and Remarks">
        <WorksheetImagesAndRemarksSection />
      </PageSection>
    </>
  );
};

AsDynamicConePenetrometerWorksheet = withInjectedProps(AsDynamicConePenetrometerWorksheet);
AsDynamicConePenetrometerWorksheet.qestIds = [qestIds.dynamicConePenetrometer.AS_1289_6_3_2.rev1997];

export default AsDynamicConePenetrometerWorksheet;
export { AsDynamicConePenetrometerWorksheet };
